import { z } from 'zod'
import { getDuplicatesRefinement } from 'src/util/src/zod'
import { DateIntervalSchema } from '../../Generic/models/DateInterval'
import { IdSchema } from '../../Generic/models/Id'

export const ProductSchema = z.object({
  id: IdSchema,
  releaseExpectedAtInterval: DateIntervalSchema,
})

export const ProductsSchema = z.array(ProductSchema)
  .superRefine(getDuplicatesRefinement('Product', parseProductUid))

export const ProductUidSchema = ProductSchema.pick({
  id: true,
})

export type Product = z.infer<typeof ProductSchema>

export type ProductUid = z.infer<typeof ProductUidSchema>

export function parseProduct(product: Product): Product {
  return ProductSchema.parse(product)
}

export function parseProducts(products: Product[]): Product[] {
  return ProductsSchema.parse(products)
}

export function parseProductUid(productUid: ProductUid): ProductUid {
  return ProductUidSchema.parse(productUid)
}
